import { BeautifulMentionsMenuProps } from "lexical-beautiful-mentions"
import * as React from "react"

import styles from "./VariablesPlugin.module.scss"

const _Menu = (
  { open, loading, ...props }: BeautifulMentionsMenuProps,
  ref: React.LegacyRef<HTMLUListElement> | undefined
) => <ul className={styles.menu} {...props} ref={ref} />

export const Menu = React.forwardRef<HTMLUListElement, BeautifulMentionsMenuProps>(_Menu)
